import { ContextHolder } from "@frontegg/react";

let fronteggAccessToken = null;

const AUTH_STORAGE_KEYS = [
  "token",
  "accessToken",
  "refresh_token",
  "sessionExpired",
  "oauth_processing",
  "oauth_redirect_in_progress",
  "loginPath",
  "adminLoginPath",
  "menu",
  "clientId",
  "userId",
  "profileId",
  "userProfileImage",
  "sendApiClientId",
  "email",
  "last",
  "rolePermission",
  "idealPath",
  "fistName",
  "lastName",
  "fronteggAccessToken",
];

export const setFronteggAccessToken = (token) => {
  fronteggAccessToken = token || null;
};

export const getFronteggAccessToken = () => fronteggAccessToken;

export const clearAuthStorage = () => {
  AUTH_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};

export const getFronteggBaseUrl = () => {
  try {
    return ContextHolder.for().getContext().baseUrl;
  } catch (error) {
    return process.env.REACT_APP_FRONTEGG_APP_URL;
  }
};

export const redirectToFronteggLogout = () => {
  try {
    // clear all storage
    clearAuthStorage();

    localStorage.clear();
    sessionStorage.clear();

    setFronteggAccessToken(null);

    const baseUrl = getFronteggBaseUrl();

    // IMPORTANT
    // redirect to separate logout page
    const postLogoutRedirectUri =
      `${window.location.origin}/logout`;

    if (baseUrl) {
      // IMPORTANT
      // replace prevents redirect history loop
      window.location.replace(
        `${baseUrl}/oauth/logout?post_logout_redirect_uri=${encodeURIComponent(
          postLogoutRedirectUri
        )}&client_id=${process.env.REACT_APP_FRONTEGG_CLIENT_ID}`
      );

      return;
    }

    window.location.replace("/logout");
  } catch (error) {
    console.error("Logout Error:", error);

    localStorage.clear();
    sessionStorage.clear();

    window.location.replace("/logout");
  }
};
